/**
 * Canonical event names for BuilderBuddi product instrumentation.
 * All trackEvent() calls must use these constants — never bare strings.
 */
export const BB_EVENTS = {
  // ── Auth ────────────────────────────────────────────────────────────────────
  SIGNUP_STARTED:        'signup_started',
  SIGNUP_COMPLETED:      'signup_completed',
  LOGIN_COMPLETED:       'login_completed',

  // ── Onboarding / Activation ──────────────────────────────────────────────────
  ONBOARDING_STEP:           'onboarding_step_completed',
  ONBOARDING_STARTED:        'onboarding_started',
  ONBOARDING_COMPLETED:      'onboarding_completed',
  ONBOARDING_SKIPPED:        'onboarding_skipped',
  ONBOARDING_ABANDONED:      'onboarding_abandoned',
  ACTIVATION_ENTRY_LOADED:   'activation_entry_loaded',
  ACTIVATION_PATH_SELECTED:  'activation_path_selected',

  // ── Calculators ─────────────────────────────────────────────────────────────
  CALCULATOR_OPENED:     'calculator_opened',
  CALCULATOR_SAVED:      'calculator_result_saved',

  // ── Field Notebook ───────────────────────────────────────────────────────────
  NOTEBOOK_ENTRY_CREATED: 'notebook_entry_created',

  // ── AI / Smart Create ────────────────────────────────────────────────────────
  SMART_CREATE_USED:     'smart_create_used',

  // ── Quotes ──────────────────────────────────────────────────────────────────
  QUOTE_CREATED:         'quote_created',
  QUOTE_SENT:            'quote_sent',
  QUOTE_CONFIRMED:       'quote_confirmed',
  AI_QUOTE_STARTED:      'ai_quote_started',
  AI_QUOTE_INPUT_SUBMITTED: 'ai_quote_input_submitted',
  AI_QUOTE_UNDERSTANDING_GENERATED: 'ai_quote_understanding_generated',
  AI_QUOTE_UNDERSTANDING_ACCEPTED: 'ai_quote_understanding_accepted',
  AI_QUOTE_MISSING_INFO_ANSWERED: 'ai_quote_missing_info_answered',
  AI_QUOTE_LINE_ITEMS_GENERATED: 'ai_quote_line_items_generated',
  AI_QUOTE_READINESS_REVIEWED: 'ai_quote_readiness_reviewed',
  AI_QUOTE_DRAFT_APPROVED: 'ai_quote_draft_approved',
  AI_QUOTE_CREATED_FROM_AI: 'ai_quote_created_from_ai',
  AI_QUOTE_ABANDONED: 'ai_quote_abandoned',
  AI_QUOTE_REGENERATED_SECTION: 'ai_quote_regenerated_section',
  AI_QUOTE_MANUAL_EDIT_AFTER_AI: 'ai_quote_manual_edit_after_ai',

  // ── Invoices & Payments ──────────────────────────────────────────────────────
  INVOICE_CREATED:       'invoice_created',
  PAYMENT_RECORDED:      'payment_recorded',
  REMINDER_TRIGGERED:    'reminder_triggered',
  OFFLINE_SYNC_COMPLETED:'offline_sync_completed',
  OFFLINE_SYNC_FAILED:   'offline_sync_failed',

  // ── Communications ──────────────────────────────────────────────────────────
  COMMUNICATION_SUBMITTED: 'communication_submitted',
  WEBSITE_INTAKE_SUBMITTED: 'website_intake_submitted',
  SUPPORT_REQUEST_SUBMITTED: 'support_request_submitted',
  INCIDENT_SUBMITTED: 'incident_submitted',
  CHANGE_REQUEST_SUBMITTED: 'change_request_submitted',
  ADMIN_COMMUNICATION_RESOLVED: 'admin_communication_resolved',
  ADMIN_REPLY_SENT: 'admin_reply_sent',

  // ── Monetisation ────────────────────────────────────────────────────────────
  LOCKED_FEATURE_VIEWED: 'locked_feature_viewed',
  UPGRADE_CTA_CLICKED:   'upgrade_cta_clicked',

  // ── Public documents ─────────────────────────────────────────────────────────
  PUBLIC_QUOTE_VIEWED:   'public_quote_viewed',
  PUBLIC_INVOICE_VIEWED: 'public_invoice_viewed',
  PUBLIC_PROFILE_VIEWED: 'public_profile_viewed',

  // ── First value milestones ───────────────────────────────────────────────────
  FIRST_JOB_CREATED:        'first_job_created',
  FIRST_CLIENT_CREATED:     'first_client_created',
  FIRST_QUOTE_CREATED:      'first_quote_created',
  FIRST_RECEIPT_UPLOADED:   'first_receipt_uploaded',
  FIRST_APPROVAL_VIEWED:    'first_approval_viewed',
  FIRST_DEMO_OPENED:        'first_demo_opened',
  FIRST_DEMO_COMPLETED:     'first_demo_completed',

  // ── Engagement ──────────────────────────────────────────────────────────────
  DASHBOARD_LOADED:          'dashboard_loaded',
  MOBILE_DASHBOARD_LOADED:   'mobile_dashboard_loaded',
  VIEWED_DEMO_PROJECT:       'viewed_demo_project',
  VIEWED_DEMO_QUOTE:         'viewed_demo_quote',
  VIEWED_DEMO_VARIATION:     'viewed_demo_variation',
  VIEWED_DEMO_RECEIPTS:      'viewed_demo_receipts',

  // ── Activation checklist ─────────────────────────────────────────────────────
  ACTIVATION_CHECKLIST_ITEM_COMPLETED: 'activation_checklist_item_completed',
  ACTIVATION_CHECKLIST_DISMISSED:      'activation_checklist_dismissed',

  // ── Retention ───────────────────────────────────────────────────────────────
  RETURNED_WITHIN_24H: 'returned_within_24h',
  RETURNED_WITHIN_7D:  'returned_within_7d',
} as const

export type BbEventName = typeof BB_EVENTS[keyof typeof BB_EVENTS]
